import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-755aca3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = { class: "dialog-body-content" }
const _hoisted_3 = { class: "handle-result-body" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "result-content" }
const _hoisted_6 = { class: "dialog-footer" }

import { t } from '@/plugins/i18n'

// import { useRtfix } from '@/store'
// import { useRouter } from 'vue-router'
// const router = useRouter()

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  resultData: {
    type: Object,
    default: () => ({})
  },
  confirmType: {
    type: String,
    default: 'ORDER'
  }
},
  emits: ['closeDialog', 'refresh'],
  setup(__props, { emit }) {

const props = __props


const getTipContent = () => {
  const value = t('此单包含X种运输方式，生成了Y个国际发货单')
  const length = props.resultData.length
  return (!length || length === 0) ? t('此订单已取消发货') : value.replace('X', length).replace('Y', length)
}
/** 取消提交 */
const cancel = () => {
  emit('closeDialog', false)
  emit('refresh')
}
/** 点击去查看 */
// const toWillHandling = () => {
//   emit('closeDialog', false)
//   emit('refresh', true)
//   const deliveryTaskCode = props.resultData?.[0]?.split('-')?.[0] ?? undefined
//   router.push(useRtfix('ShippingList', { query: { deliveryStatus: '0,1,2,3,4', deliveryTaskCode } }))
// }


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "close-on-click-modal": false,
    class: "problem-result-order-shipping",
    "custom-class": "problem-result-order-shipping",
    width: 500,
    "model-value": __props.visible,
    "destroy-on-close": "",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('closeDialog', false))),
    draggable: ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_6, [
        _createVNode(_component_el_button, {
          class: "close",
          onClick: cancel,
          style: { marginRight: '24px' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('知道了')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "result-tip",
            innerHTML: getTipContent()
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.resultData, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item,
                class: "result-content-num"
              }, _toDisplayString(item), 1))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})